function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as t } from "./index.es33.js";
import { memo as p } from "react";
import { clsx as s } from "./index.es105.js";
import "./index.es93.js";
import "./index.es94.js";
import "./index.es95.js";
import "./index.es96.js";
import "./index.es97.js";
import "./index.es98.js";
import "./index.es99.js";
import "./index.es100.js";
import "./index.es101.js";
import "./index.es102.js";
import "./index.es103.js";
import "./index.es104.js";
import { palette as e } from "./index.es36.js";
import { Icon as a } from "./index.es7.js";
import { EMOJI_CATEGORIES as n } from "./index.es621.js";
import m from "./index.es622.js";

var c = function c(_ref) {
  var r = _ref.current,
      i = _ref.setCurrent;
  return t.jsx("ul", {
    className: m.list,
    children: n.map(function (o) {
      return t.jsx("li", {
        className: s(m.item, _defineProperty({}, m.itemActive, o.name === r)),
        children: t.jsx("button", {
          type: "button",
          className: m.button,
          onClick: function onClick() {
            return i(o.name);
          },
          children: t.jsx(a, {
            icon: o.icon,
            size: 18,
            color: e.gray5
          })
        })
      }, o.name);
    })
  });
},
    v = /*#__PURE__*/p(c);

export { v as default };